var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 500 500",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41022 250.363C5.41022 115.589 114.666 6.33356 249.44 6.33356C384.213 6.33356 493.469 115.589 493.469 250.363C493.469 385.137 384.213 494.392 249.44 494.392C114.666 494.392 5.41022 385.137 5.41022 250.363Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#aa7d50",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373.289 253.975C372.295 293.938 357.62 331.91 319.979 357.777C251.746 404.786 156.65 367.395 137.996 286.559C128.627 245.934 132.357 206.884 156.236 171.813C183.016 132.516 221.733 116.596 268.244 121.903C314.011 127.126 345.266 153.242 363.174 195.443C370.471 212.769 373.123 230.928 373.289 253.975ZM360.355 247.178C359.693 241.042 359.278 232.419 357.869 223.88C356.791 217.33 354.801 210.947 352.645 204.646C326.197 128.536 229.278 107.975 176.134 168.415C141.23 208.128 137.913 255.136 158.142 302.726C183.596 362.585 257.301 383.893 311.108 347.745C345.681 324.697 359.112 290.123 360.355 247.178Z",
    fill: "#aa7d50",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.237 356.782C132.357 332.904 109.973 298.498 109.309 251.405C108.645 202.737 130.947 167.004 171.988 142.049C139.572 170.569 123.652 206.469 123.652 249.498C123.735 292.61 139.737 328.427 172.237 356.782Z",
    fill: "#aa7d50",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M333.907 356.616C400.565 303.555 398.741 193.951 334.157 142.547C363.671 154.902 396.09 196.851 397.664 244.608C399.653 302.146 362.677 344.181 333.907 356.616Z",
    fill: "#aa7d50",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.836 265.831L282.836 233.497L254.814 217.247L226.707 233.497L226.707 265.831L254.814 282.082L282.836 265.831Z",
    fill: "#aa7d50",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObol);
export default __webpack_public_path__ + "static/media/obol.c948e3e8f2363242e318195336d17fb9.svg";
export { ForwardRef as ReactComponent };